module.exports = __webpack_public_path__ + "media/images/users/phone-aad0df3bc483d7c4c94f95db4b3fc525.png";